<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST">

      <div class="form-group row" :class="{'has-error': !data.appointmentAt}">
        <label for="appointment_at" class="col-form-label col-sm-3">Appointment Date:</label>
        <div class="col-sm-9">
          <datepicker
            v-model="data.appointmentAt"
            :invalid-state="!data.appointmentAt"
            :with-time="true"
            name="appointment_at">
          </datepicker>
        </div>
      </div>

      <input type="hidden" name="_method" value="PATCH">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">
        <i class="fa fa-fw fa-close"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary" :disabled="!submitEnable" name="submit_adjuster_appointment" :form="formId">
        <i class="fa fa-fw fa-save"></i> Submit
      </button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
export default {

  /**
   *
   * Modal form used to set claim date and related data.
   *
   * Input properties:
   *
   * modalId - custom id for modal component.
   * action  - form action URL.
   * title   - form title.
   *
   * Usage examples:
   *
   * <appointment-modal modal-id="adjusterAppointmentModal"
   *                         action="{{ route('claims.submit', compact('claim')) }}"
   *                         title="Adjuster Appointment">
   *   <a href="#" class="" v-modal="'adjusterAppointmentModal'">Update</a>
   * </appointment-modal>
   */

  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'adjusterAppointmentModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Form title.
    title: {
      type: String,
      default: ""
    },

    appointmentAt: {
      type: String,
      default: ""
    },
  },

  /**
   * Variables (models).
   */
  data() {
    return {
      data: {
        appointmentAt: this.appointmentAt,
      }
    }
  },

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    },

    submitEnable() {
      return this.data.appointmentAt;
    },

  },
}
</script>
